import { MENU_PADDING_RIGHT } from '../../../services/theme'

export default {
    root: {
        padding: 0,
        paddingRight: MENU_PADDING_RIGHT,
        margin: 0
    }
}